import React, { useEffect, useState } from "react";
import { getTestimonialsApi } from "@/lib/api";
import { RatingStars } from "@/components/ProductCard";
import ScrollReveal from "@/components/ScrollReveal";
import { Quote } from "lucide-react";

const DEFAULTS = [
  { name: "Aarav M.", rating: 5, title: "Genuinely soft", body: "The modal fabric feels premium and holds up wash after wash. Easily the most comfortable innerwear I own.", product: "" },
  { name: "Ishita R.", rating: 5, title: "Perfect fit", body: "True to size and the finish is beautiful. You can tell a lot of thought went into the details.", product: "" },
  { name: "Karan S.", rating: 5, title: "Quiet luxury, delivered", body: "Elegant packaging, fast delivery and the quality lives up to the promise. Will be ordering again.", product: "" },
];

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    getTestimonialsApi().then((d) => setItems(d.testimonials && d.testimonials.length ? d.testimonials : DEFAULTS)).catch(() => setItems(DEFAULTS));
  }, []);
  if (!items.length) return null;
  const show = items.slice(0, 3);

  return (
    <section className="bg-lemce-cream/60 border-y border-lemce-beige/60 py-20 lg:py-28" data-testid="home-testimonials">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <ScrollReveal className="mb-12 text-center">
          <p className="text-[11px] tracking-[0.3em] uppercase text-lemce-taupe mb-3">Loved By Our Customers</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl">Comfort worth talking about</h2>
        </ScrollReveal>
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {show.map((t, i) => (
            <ScrollReveal key={i} delay={i * 0.08}>
              <figure className="h-full bg-lemce-ivory border border-lemce-beige p-8 flex flex-col" data-testid={`testimonial-${i}`}>
                <Quote className="w-7 h-7 text-lemce-taupe/50 mb-4" strokeWidth={1.5} />
                <RatingStars value={t.rating} />
                {t.title && <p className="font-medium text-sm mt-4">{t.title}</p>}
                <blockquote className="text-sm text-lemce-charcoal leading-relaxed mt-2 flex-1">"{t.body}"</blockquote>
                <figcaption className="text-[11px] tracking-widest uppercase text-lemce-grey mt-6">
                  {t.name}{t.product ? ` · ${t.product}` : ""}
                </figcaption>
              </figure>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
